// import 'react-hot-loader';
// import "@babel/polyfill";
import 'core-js/actual';
import 'bootstrap';
// import 'bootstrap-icons';
import "slick-carousel";
import './style.scss';

import './js/views-public';
import './js/agenda-collapsing';